export default "__VITE_ASSET__DFOsuXb$__"